import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AIYukleme = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [result, setResult] = useState(null);
  const [bulkResults, setBulkResults] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [error, setError] = useState('');
  const [mode, setMode] = useState('vinc');
  const [siparisler, setSiparisler] = useState([]);
  const [selectedSiparis, setSelectedSiparis] = useState('');

  useEffect(() => {
    fetchSiparisler();
  }, []);

  const fetchSiparisler = async () => {
    try {
      const token = localStorage.getItem('token');
      const [sipRes, musteriRes] = await Promise.all([
        axios.get(`${API}/siparisler`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/musteriler`, { headers: { Authorization: `Bearer ${token}` } })
      ]);
      
      const musteriler = musteriRes.data;
      const siparislerWithMusteri = sipRes.data.map(s => {
        const musteri = musteriler.find(m => m.id === s.musteri_id);
        return { ...s, musteri_adi: musteri?.ad || '' };
      });
      
      setSiparisler(siparislerWithMusteri);
    } catch (err) {
      console.error('Siparişler yüklenemedi');
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 10 * 1024 * 1024) {
        setError('Dosya 10MB\'dan küçük olmalı');
        return;
      }
      setFile(selectedFile);
      setError('');
      setResult(null);
      setBulkResults(null);
      setSelectedItems([]);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Dosya seçin');
      return;
    }

    setLoading(true);
    setError('');

    const formData = new FormData();
    formData.append('file', file);

    try {
      const token = localStorage.getItem('token');
      let endpoint = '';
      
      if (mode === 'musteri') {
        endpoint = '/ai/parse-customer';
      } else if (mode === 'musteri-bulk') {
        endpoint = '/ai/parse-customers-bulk';
      } else {
        endpoint = '/ai/parse-crane';
      }
      
      const response = await axios.post(`${API}${endpoint}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.data.success) {
        if (mode === 'musteri-bulk') {
          setBulkResults(response.data.data);
          setSelectedItems(response.data.data.map((_, i) => i));
        } else {
          setResult(response.data.data);
        }
      } else {
        setError(response.data.error || 'AI analizi başarısız');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveVinc = async () => {
    if (!selectedSiparis) {
      setError('Lütfen bir sipariş seçin');
      return;
    }

    setSaving(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      
      const vincData = {
        siparis_id: selectedSiparis,
        seri_no: result.seri_no || '',
        vinc_tipi: result.vinc_tipi || 'Köprü',
        kapasite: result.kapasite || '',
        aciklik: result.aciklik || '',
        yukseklik: result.yukseklik || '',
        derinlik: result.derinlik || '',
        direk_aralari: result.direk_aralari || '',
        kaldirma_tipi: result.kaldirma_tipi || '',
        donam: result.donam || '',
        ana_reduksiyon: result.ana_reduksiyon || '',
        kaldirma_motor_kw: result.kaldirma_motor_kw || '',
        kaldirma_motor_devir: result.kaldirma_motor_devir || '',
        kaldirma_hizi: result.kaldirma_hizi || '',
        kaldirma_hizi_2: result.kaldirma_hizi_2 || '',
        halat_cap: result.halat_cap || '',
        halat_tipi: result.halat_tipi || '',
        halat_boyu: result.halat_boyu || '',
        tambur_cap: result.tambur_cap || '',
        tambur_boyu: result.tambur_boyu || '',
        kanca: result.kanca || '',
        calisma_profili: result.calisma_profili || '',
        calisma_aksi: result.calisma_aksi || '',
        calisma_rayi: result.calisma_rayi || '',
        yurutme_reduktoru: result.yurutme_reduktoru || '',
        yurutme_reduktoru_adeti: result.yurutme_reduktoru_adeti || '',
        kedi_yurutme_hizi: result.kedi_yurutme_hizi || '',
        kedi_yurutme_hizi_2: result.kedi_yurutme_hizi_2 || '',
        teker_cap_kedi: result.teker_cap_kedi || '',
        teker_tipi_kedi: result.teker_tipi_kedi || '',
        kaldirma_makinasi_rengi: result.kaldirma_makinasi_rengi || '',
        alt_ust_sac_olcu: result.alt_ust_sac_olcu || '',
        alt_ust_sac_kalinlik: result.alt_ust_sac_kalinlik || '',
        alt_ust_sac_adet: result.alt_ust_sac_adet || '',
        alt_ust_sac_agirlik: result.alt_ust_sac_agirlik || '',
        yan_sac_olcu: result.yan_sac_olcu || '',
        yan_sac_kalinlik: result.yan_sac_kalinlik || '',
        yan_sac_adet: result.yan_sac_adet || '',
        yan_sac_agirlik: result.yan_sac_agirlik || '',
        kopru_rayi_olcu: result.kopru_rayi_olcu || '',
        kopru_rayi_adet: result.kopru_rayi_adet || '',
        kopru_rayi_agirlik: result.kopru_rayi_agirlik || '',
        ic_dikme_olcu: result.ic_dikme_olcu || '',
        ic_dikme_adet: result.ic_dikme_adet || '',
        ic_dikme_agirlik: result.ic_dikme_agirlik || '',
        kosebent_olcu: result.kosebent_olcu || '',
        kosebent_adet: result.kosebent_adet || '',
        kosebent_agirlik: result.kosebent_agirlik || '',
        yurume_yolu_ray_profili: result.yurume_yolu_ray_profili || '',
        yurume_yolu_adet: result.yurume_yolu_adet || '',
        yurume_yolu_agirlik: result.yurume_yolu_agirlik || '',
        yurume_yolu_rayi: result.yurume_yolu_rayi || '',
        yurume_yolu_rayi_adet: result.yurume_yolu_rayi_adet || '',
        yurume_yolu_rayi_agirlik: result.yurume_yolu_rayi_agirlik || '',
        yurume_yolu_rayalti: result.yurume_yolu_rayalti || '',
        yurume_yolu_direkleri: result.yurume_yolu_direkleri || '',
        ankraj: result.ankraj || '',
        sac_olcusu: result.sac_olcusu || '',
        baslik_profili: result.baslik_profili || '',
        teker_cap_kopru: result.teker_cap_kopru || '',
        teker_tipi_kopru: result.teker_tipi_kopru || '',
        kopru_calisma_rayi: result.kopru_calisma_rayi || '',
        kopru_yurutme_reduktoru: result.kopru_yurutme_reduktoru || '',
        kopru_yurutme_reduktor_adet: result.kopru_yurutme_reduktor_adet || '',
        kopru_yurutme_hizi: result.kopru_yurutme_hizi || '',
        kopru_yurutme_hizi_2: result.kopru_yurutme_hizi_2 || '',
        celik_konstruksiyon_rengi: result.celik_konstruksiyon_rengi || '',
        pano_ebadi: result.pano_ebadi || '',
        pano_konumu: result.pano_konumu || '',
        kaldirma_motor_detay: result.kaldirma_motor_detay || '',
        kedi_yurutme_motor_detay: result.kedi_yurutme_motor_detay || '',
        kopru_yurutme_motor_detay: result.kopru_yurutme_motor_detay || '',
        kumanda_tipi: result.kumanda_tipi || '',
        uzaktan_kumanda_model: result.uzaktan_kumanda_model || '',
        hareket_sayisi: result.hareket_sayisi || '',
        sesli_isikli_ikaz: result.sesli_isikli_ikaz || '',
        tur_sivici: result.tur_sivici || '',
        limit_sivici: result.limit_sivici || '',
        asiri_yuk_sivici: result.asiri_yuk_sivici || '',
        kopru_enerji_uzunluk: result.kopru_enerji_uzunluk || '',
        kopru_enerji_sistem: result.kopru_enerji_sistem || '',
        hol_enerji_uzunluk: result.hol_enerji_uzunluk || '',
        hol_enerji_sistem: result.hol_enerji_sistem || '',
        notlar: result.notlar || '',
        dosyalar: []
      };

      await axios.post(`${API}/vincler`, vincData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('✅ Vinç başarıyla kaydedildi!');
      navigate('/vincler');
    } catch (err) {
      setError(err.response?.data?.detail || 'Vinç kaydedilemedi');
    } finally {
      setSaving(false);
    }
  };

  const handleSaveMusteri = async () => {
    setSaving(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      
      const musteriData = {
        ad: result.firma_adi || '',
        temsilci: result.yetkili_kisi || '',
        telefon: result.telefon || '',
        email: result.email || '',
        adres: result.adres || '',
        sehir: result.sehir || '',
        vergi_dairesi: result.vergi_dairesi || '',
        vergi_no: result.vergi_no || '',
        telefonlar: []
      };

      await axios.post(`${API}/musteriler`, musteriData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const res = response;
      alert(`✅ ${res.data.created} yeni müşteri eklendi, ${res.data.updated} müşteri güncellendi!`);
      navigate('/musteriler');
    } catch (err) {
      setError(err.response?.data?.detail || 'Müşteri kaydedilemedi');
    } finally {
      setSaving(false);
    }
  };

  const handleSaveBulkMusteriler = async () => {
    if (selectedItems.length === 0) {
      setError('En az bir müşteri seçin');
      return;
    }

    setSaving(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      
      const musterilerData = selectedItems.map(i => {
        const m = bulkResults[i];
        return {
          ad: m.firma_adi || '',
          temsilci: m.yetkili_kisi || '',
          telefon: m.telefon || '',
          email: m.email || '',
          adres: m.adres || '',
          sehir: m.sehir || '',
          vergi_dairesi: m.vergi_dairesi || '',
          vergi_no: m.vergi_no || '',
          telefonlar: []
        };
      });

      const response = await axios.post(`${API}/musteriler/bulk`, musterilerData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert(`✅ ${selectedItems.length} müşteri başarıyla kaydedildi!`);
      navigate('/musteriler');
    } catch (err) {
      setError(err.response?.data?.detail || 'Müşteriler kaydedilemedi');
    } finally {
      setSaving(false);
    }
  };

  const toggleSelectItem = (index) => {
    if (selectedItems.includes(index)) {
      setSelectedItems(selectedItems.filter(i => i !== index));
    } else {
      setSelectedItems([...selectedItems, index]);
    }
  };

  const toggleSelectAll = () => {
    if (selectedItems.length === bulkResults.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(bulkResults.map((_, i) => i));
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">🤖 AI Dosya Yükleme</h1>
        <p className="page-subtitle">PDF, Word veya Excel dosyalarından otomatik veri çıkarma</p>
      </div>

      <div className="card" style={{maxWidth:'1000px'}}>
        {/* Mod Seçimi */}
        <div style={{marginBottom:'24px'}}>
          <label style={{display:'block',marginBottom:'12px',fontWeight:'600'}}>Ne çıkarmak istiyorsunuz?</label>
          <div style={{display:'flex',gap:'12px',flexWrap:'wrap'}}>
            <button
              onClick={() => {setMode('musteri'); setResult(null); setBulkResults(null); setFile(null);}}
              style={{
                flex:1, minWidth:'150px', padding:'16px', border:'none', borderRadius:'12px', cursor:'pointer',
                background: mode === 'musteri' ? 'linear-gradient(135deg, #3b82f6, #2563eb)' : '#f1f5f9',
                color: mode === 'musteri' ? 'white' : '#475569', fontWeight:'600'
              }}
            >
              👤 Tek Müşteri
            </button>
            <button
              onClick={() => {setMode('musteri-bulk'); setResult(null); setBulkResults(null); setFile(null);}}
              style={{
                flex:1, minWidth:'150px', padding:'16px', border:'none', borderRadius:'12px', cursor:'pointer',
                background: mode === 'musteri-bulk' ? 'linear-gradient(135deg, #8b5cf6, #7c3aed)' : '#f1f5f9',
                color: mode === 'musteri-bulk' ? 'white' : '#475569', fontWeight:'600'
              }}
            >
              👥 Çoklu Müşteri (Toplu)
            </button>
            <button
              onClick={() => {setMode('vinc'); setResult(null); setBulkResults(null); setFile(null);}}
              style={{
                flex:1, minWidth:'150px', padding:'16px', border:'none', borderRadius:'12px', cursor:'pointer',
                background: mode === 'vinc' ? 'linear-gradient(135deg, #10b981, #059669)' : '#f1f5f9',
                color: mode === 'vinc' ? 'white' : '#475569', fontWeight:'600'
              }}
            >
              🏗️ Vinç Özellikleri
            </button>
          </div>
        </div>

        {mode === 'musteri-bulk' && (
          <div style={{marginBottom:'20px',padding:'16px',background:'#fef3c7',borderRadius:'8px',color:'#92400e'}}>
            💡 <strong>İpucu:</strong> Birden fazla firma içeren PDF yükleyin. AI tüm firmaları otomatik bulacak.
          </div>
        )}

        {/* Dosya Seçimi */}
        <div style={{border:'2px dashed #cbd5e1',borderRadius:'12px',padding:'40px',textAlign:'center',background:file?'#f0fdf4':'#f8fafc'}}>
          {file ? (
            <div>
              <div style={{fontSize:'48px'}}>📄</div>
              <div style={{fontSize:'18px',fontWeight:'600',color:'#16a34a'}}>{file.name}</div>
              <div style={{fontSize:'14px',color:'#64748b'}}>{(file.size/1024).toFixed(1)} KB</div>
            </div>
          ) : (
            <div>
              <div style={{fontSize:'48px'}}>📁</div>
              <div style={{fontSize:'18px',fontWeight:'600',marginBottom:'16px'}}>Dosya Seçin</div>
              <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg" onChange={handleFileChange} style={{marginBottom:'16px'}}/>
              <div style={{fontSize:'12px',color:'#94a3b8'}}>PDF, Word, Excel, Resim (Maks. 10MB)</div>
            </div>
          )}
        </div>

        {/* Hata */}
        {error && (
          <div style={{marginTop:'16px',padding:'12px',background:'#fee2e2',color:'#991b1b',borderRadius:'8px'}}>
            ❌ {error}
          </div>
        )}

        {/* Yükle Butonu */}
        {file && !result && !bulkResults && (
          <button
            onClick={handleUpload}
            disabled={loading}
            style={{
              width:'100%', marginTop:'20px', padding:'16px', border:'none', borderRadius:'8px',
              background: loading ? '#94a3b8' : 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
              color:'white', fontSize:'16px', fontWeight:'600', cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? '⏳ AI Analiz Ediyor...' : '🚀 AI ile Analiz Et'}
          </button>
        )}

        {/* Çoklu Müşteri Sonuçları */}
        {bulkResults && (
          <div style={{marginTop:'24px'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <h3>✅ {bulkResults.length} Müşteri Bulundu</h3>
              <button onClick={toggleSelectAll} style={{padding:'8px 16px',border:'1px solid #cbd5e1',borderRadius:'6px',background:'white',cursor:'pointer'}}>
                {selectedItems.length === bulkResults.length ? '☐ Seçimi Kaldır' : '☑ Tümünü Seç'}
              </button>
            </div>
            
            <div style={{background:'#f8fafc',borderRadius:'12px',padding:'16px',maxHeight:'400px',overflowY:'auto'}}>
              {bulkResults.map((musteri, index) => (
                <div 
                  key={index} 
                  onClick={() => toggleSelectItem(index)}
                  style={{
                    display:'flex', alignItems:'center', gap:'12px', padding:'12px', marginBottom:'8px',
                    background: selectedItems.includes(index) ? '#dbeafe' : 'white',
                    borderRadius:'8px', cursor:'pointer', border:'1px solid #e2e8f0'
                  }}
                >
                  <input 
                    type="checkbox" 
                    checked={selectedItems.includes(index)} 
                    onChange={() => {}}
                    style={{width:'20px',height:'20px'}}
                  />
                  <div style={{flex:1}}>
                    <div style={{fontWeight:'600',color:'#1e293b'}}>{musteri.firma_adi || 'İsimsiz Firma'}</div>
                    <div style={{fontSize:'13px',color:'#64748b'}}>
                      {musteri.sehir && `📍 ${musteri.sehir}`}
                      {musteri.telefon && ` • 📞 ${musteri.telefon}`}
                      {musteri.email && ` • ✉️ ${musteri.email}`}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{marginTop:'20px',padding:'16px',background:'#eff6ff',borderRadius:'12px'}}>
              <div style={{marginBottom:'12px',color:'#1e40af',fontWeight:'600'}}>
                {selectedItems.length} müşteri seçildi
              </div>
              <button
                onClick={handleSaveBulkMusteriler}
                disabled={saving || selectedItems.length === 0}
                style={{
                  width:'100%', padding:'16px', border:'none', borderRadius:'8px',
                  background: saving || selectedItems.length === 0 ? '#94a3b8' : 'linear-gradient(135deg, #10b981, #059669)',
                  color:'white', fontSize:'16px', fontWeight:'600', cursor: saving || selectedItems.length === 0 ? 'not-allowed' : 'pointer'
                }}
              >
                {saving ? '⏳ Kaydediliyor...' : `💾 ${selectedItems.length} Müşteriyi Kaydet`}
              </button>
            </div>

            <button
              onClick={() => {setBulkResults(null);setFile(null);setSelectedItems([]);}}
              style={{marginTop:'16px',padding:'12px 24px',border:'1px solid #e2e8f0',borderRadius:'8px',background:'white',cursor:'pointer'}}
            >
              🔄 Yeni Dosya Yükle
            </button>
          </div>
        )}

        {/* Tek Sonuç (Vinç veya Tek Müşteri) */}
        {result && (
          <div style={{marginTop:'24px'}}>
            <h3 style={{marginBottom:'16px'}}>✅ Sonuçlar ({Object.keys(result).filter(k => result[k]).length} alan bulundu)</h3>
            
            <div style={{background:'#f8fafc',borderRadius:'12px',padding:'20px',maxHeight:'400px',overflowY:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <tbody>
                  {Object.entries(result).filter(([k,v]) => v).map(([key, value]) => (
                    <tr key={key} style={{borderBottom:'1px solid #e2e8f0'}}>
                      <td style={{padding:'10px',fontWeight:'600',color:'#334155',width:'40%',fontSize:'13px'}}>{key.replace(/_/g,' ')}</td>
                      <td style={{padding:'10px',color:'#1e293b',fontSize:'13px'}}>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Kaydet Bölümü */}
            <div style={{marginTop:'24px',padding:'20px',background:'#eff6ff',borderRadius:'12px'}}>
              {mode === 'vinc' ? (
                <>
                  <label style={{display:'block',marginBottom:'8px',fontWeight:'600'}}>Sipariş Seçin *</label>
                  <select 
                    value={selectedSiparis} 
                    onChange={(e) => setSelectedSiparis(e.target.value)}
                    style={{width:'100%',padding:'12px',border:'1px solid #cbd5e1',borderRadius:'8px',marginBottom:'16px'}}
                  >
                    <option value="">-- Sipariş Seçin --</option>
                    {siparisler.map(s => (
                      <option key={s.id} value={s.id}>{s.siparis_no} - {s.musteri_adi || 'Müşteri'}</option>
                    ))}
                  </select>
                  <button
                    onClick={handleSaveVinc}
                    disabled={saving || !selectedSiparis}
                    style={{
                      width:'100%', padding:'16px', border:'none', borderRadius:'8px',
                      background: saving || !selectedSiparis ? '#94a3b8' : 'linear-gradient(135deg, #10b981, #059669)',
                      color:'white', fontSize:'16px', fontWeight:'600', cursor: saving || !selectedSiparis ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {saving ? '⏳ Kaydediliyor...' : '💾 Vinç Olarak Kaydet'}
                  </button>
                </>
              ) : (
                <button
                  onClick={handleSaveMusteri}
                  disabled={saving}
                  style={{
                    width:'100%', padding:'16px', border:'none', borderRadius:'8px',
                    background: saving ? '#94a3b8' : 'linear-gradient(135deg, #10b981, #059669)',
                    color:'white', fontSize:'16px', fontWeight:'600', cursor: saving ? 'not-allowed' : 'pointer'
                  }}
                >
                  {saving ? '⏳ Kaydediliyor...' : '💾 Müşteri Olarak Kaydet'}
                </button>
              )}
            </div>

            <button
              onClick={() => {setResult(null);setFile(null);setSelectedSiparis('');}}
              style={{marginTop:'16px',padding:'12px 24px',border:'1px solid #e2e8f0',borderRadius:'8px',background:'white',cursor:'pointer'}}
            >
              🔄 Yeni Dosya Yükle
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AIYukleme;